import { Store } from 'src/store/index';

const getMinPagesCount = (store: Store) => store.design.structure?.page_count_limit?.min;

export default getMinPagesCount;
